import * as React from 'react';
import { Form, Modal, Button, Tabs, Tab, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';

import EntityHierRelationshipImport from "./EntityHierRelationshipImport";

import {adriva_getEntityRelationships, } from './API';

interface EntityHierRelationshipProps{
    appNm: string;
    entities: any[];
    relationships: any[];
    hierarchies: any[];
    handleRelAndHierarchySave: (rel: any, hier: any) => void;
}

interface EntityHierRelationshipState {
  tabKey: string;
  showRelImportModal: boolean;
  importRelationships: any[];
  importHierarchies: any[];
  selectedRelationship: any;
  relImportAction: string;
}


class EntityHierRelationship extends React.Component<EntityHierRelationshipProps, EntityHierRelationshipState> {
  constructor(props: EntityHierRelationshipProps) {
    super(props);
    this.state = {
      tabKey: 'tabRel',
      showRelImportModal: false,
      importRelationships: [],
      importHierarchies: [],
      selectedRelationship: null,
      relImportAction: 'ADD',
    };
  }
  
  componentDidUpdate(prevProps: EntityHierRelationshipProps) {
    if (prevProps.relationships !== this.props.relationships) {
      console.log('relationships prop has changed!');
    }
  }

  toggleShowRelImportModal = ()=>{
    this.setState({showRelImportModal: !this.state.showRelImportModal});
  }
  
  handleTabSelect = (tabKey: string | null) => {
    if (tabKey) {
      this.setState({ tabKey });
    }
  };
  
  handleInportRelAndHierarchy = () =>{
	
	const tableList = [...new Set(this.props.entities.map((e: any) => {
	  return e.field[0].FLD_PHYSICAL_ID.split('-')[0]
	}))];
	
	adriva_getEntityRelationships(this.props.appNm, JSON.stringify(tableList),
		(res: any) => {
		  console.log(res);
		  if (res.success){
			 this.setState({showRelImportModal: true, relImportAction: 'IMPORT', selectedRelationship: null, 
              importRelationships: res.data.relationships, importHierarchies: res.data.hierarchies})
		  }else{
			  
		  }
		  
		},
		(error: any) => {
		  console.log(error);
		}
	);
	  
   }
  
  handleEdit = (id: string) => {
    const selectedRelationship = this.props.relationships.filter((r:any)=> {return r['@id'] === id})[0];
    this.setState({showRelImportModal: true, relImportAction: 'EDIT', selectedRelationship, importHierarchies: this.props.hierarchies })
  };

  handleDelete = (id: string) => {
    // implement delete logic
  };

  
  renderRelTableHeader = () => {
    return (
      <thead className="thead-light">
        <tr>
          <th>Hierarchy</th>
          <th>Relationship</th>
          <th>Start Entity</th>
          <th>End Entity</th>  
          <th>Direction</th>  
          <th>Actions</th>
        </tr>
      </thead>
    );
  };

  renderRelTableRow = (relationship: any, index: number) => {
    const hier =  this.props.hierarchies.filter((e:any) => {return e['@id'] === relationship['@parentId']})[0];
    const startEntity = this.props.entities.filter((e:any) => {return e.id === relationship.fromObject})[0];
    const endEntity = this.props.entities.filter((e:any) => {return e.id === relationship.toObject})[0];

    if (!startEntity || !endEntity) {
      return null;
    }
    return (
      <tr key={relationship['@id']} className={index % 2 === 0 ? 'table-row-even' : 'table-row-odd'}>
        <td>{hier.label} ({hier.name})</td>
        <td>{relationship.label} ({relationship.name})</td>
        <td>{startEntity.label}</td>
        <td>{endEntity.label}</td>
        <td>{relationship.relDirection}</td>
        <td>
          <Button variant=""  style={{ padding: 3 }} 
            onClick={() => this.handleEdit(relationship['@id'])}>
            <FontAwesomeIcon icon={faPen} style={{ fontSize: '12px', color: 'grey' }}  />
          </Button>
          <Button variant="" style={{ padding: 3 }} onClick={() => this.handleDelete(relationship['@id'])}>
            <FontAwesomeIcon icon={faTrash} style={{ fontSize: '12px', color: 'red' }}  />
          </Button>
        </td>
      </tr>
    );
  };
  


  render() {
   
    const {relationships} =  this.props;
    console.log("relationships :: " + relationships)
   
      
    return (
      <div>
        
        <div className="tab-container mt-1" style={{ paddingLeft:'10px', paddingRight:'10px'}}>
			<Tabs id="controlled-tab-dm"
			  activeKey={this.state.tabKey}
			  onSelect={this.handleTabSelect}
			  className="mb-3"
			>
			  <Tab eventKey="tabRel" title="Relationships">
				  <div className="tab-content" style ={{height:'940px'}}>
                    <div className="d-flex justify-content-end mb-3">
                        <div>
                            <Button variant="primary" type="submit" onClick={this.handleInportRelAndHierarchy} style={{marginLeft:'10px'}} size="sm">
                                Import
                            </Button>
                            <Button variant="primary" type="submit" onClick={this.handleInportRelAndHierarchy} style={{marginLeft:'10px'}} size="sm">
                                Add
                            </Button>
                        </div>
                    </div>
                    
                    <Table striped bordered hover variant="light">
                      {this.renderRelTableHeader()}
                      <tbody>
                        {this.props.relationships.map((relationship, index) => this.renderRelTableRow(relationship, index))}
                      </tbody>
                    </Table>

                </div>
              </Tab>
              <Tab eventKey="tabHier" title="Hierarchy">
				  <div className="tab-content" style ={{height:'940px'}}>
                    <div className="d-flex justify-content-end">
                        <div>
                            <Button variant="primary" type="submit" onClick={this.handleInportRelAndHierarchy} style={{marginLeft:'10px'}} size="sm">
                                Import
                            </Button>
                            <Button variant="primary" type="submit" onClick={this.handleInportRelAndHierarchy} style={{marginLeft:'10px'}} size="sm">
                                Add
                            </Button>
                        </div>
                    </div>
                </div>
              </Tab>
          </Tabs>
        </div>
        
        
        
        
        {this.state.showRelImportModal &&
		<Modal show={this.state.showRelImportModal} onHide={this.toggleShowRelImportModal} 
		  backdrop="static"
		  keyboard={false}>
			<Modal.Header closeButton>
			  <Modal.Title>Inport Relationships</Modal.Title>
			</Modal.Header>
			<Modal.Body>
			  <div>
				  <EntityHierRelationshipImport entities={this.props.entities} relImportAction={this.state.relImportAction} 
                    relationships={this.state.importRelationships}
                    selectedRelationship={this.state.selectedRelationship}
                    hierarchies={this.state.importHierarchies} handleRelAndHierarchySave={this.props.handleRelAndHierarchySave}
                    toggleShowRelImportModal={this.toggleShowRelImportModal}/>
			  </div>
			</Modal.Body>
            
		</Modal>
		}
        
      </div>
    );
  }
}

export default EntityHierRelationship;